module.exports = __webpack_public_path__ + "img/hands-praying.5ec27137.svg";